import Vue from "vue";

Vue.filter("status", (str) => {
    switch (str) {
        case 10:
            return "مدخل";
        case 1:
            return "مفعل";
        case 2:
            return "مجمد";
        case 4:
            return "مرفوض";
        case 5:
            return "معتمد";
        case 8:
            return "مستخدم";
        case 11:
            return "منتهي";
        case 16:
            return "تم الرد";



    }
});
Vue.filter("promotionsStatus", (str) => {
    switch (str) {
        case 10:
            return "مدخل";
        case 1:
            return "معتمد";
        case 12:
            return "غير مستكمل";
    }
});
Vue.filter("operationStatus", (str) => {
    switch (str) {
        case 10:
            return "مدخل";
        case 1:
            return "معتمد";
        case 4:
            return "مرفوض";
        case 12:
            return "غير مستكمل";
    }
});
Vue.filter("employeeStatus", (str) => {
    switch (str) {
        case 1:
            return "موظف دائم";
        case 2:
            return "متوفى";
        case 3:
            return "مُستقيل ";
        case 4:
            return " مَقال ";
        case 6:
            return " متقاعد ";
        case 7:
            return " منتقل ";  
              case 8:
            return " عدم اليقة الصحية ";
        case 9:
            return "  الحكم عليه بجناية ";

        
    }
});

Vue.filter("gender", (str) => {
    switch (str) {
        case 1:
            return "ذكر";
        case 2:
            return "انثي ";
    }
});
Vue.filter("boolString", (str) => {
    switch (str) {
        case 0:
            return "تنتهي اليوم";
        case 1:
            return "تنتهي بالغد ";
        case 2:
            return "تنتهي بعد يومان ";
        case 4:
            return "اكتر من يومان ";
        case 5:
            return "منتهيه مسبقا ";
    }
});

Vue.filter("userTypes", (str) => {
    switch (str) {
        case 1001:
            return "إداري";
        case 1003:
            return " مدير قسم";
        case 1002:
            return "مستخدم الموارد البشرية";
    }
});



Vue.filter("null", (str) => {
    if (str === "" || str === null) return "لا يوجد";
    else return str;
});

Vue.filter("requsetType", (str) => {
    if (str == true) return "الموظف";
    else return "الشؤون الإدارية والخدمات";
});

Vue.filter("empty", (str) => {
    if (str === "" || str === null) return "-";
    else return str;
});
Vue.filter("remainingAmout", (value, arg) => {
    const date1 = new Date(value);
    console.log(arg);
    const date2 = new Date();
    var retirementAge = arg == 1 ? 65 : 60;

    const differenceInDays = Math.floor((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));
    var age = Math.floor(differenceInDays / 365)
    var amount = (retirementAge - age) + age;
    date1.setDate(date1.getDate() + 1);

    return new Date(date1.setFullYear(date1.getFullYear() + amount)).toISOString().slice(0, 10).split('-').reverse().join('/');

});
Vue.filter("age", (value) => {
    const date1 = new Date(value);
    const date2 = new Date();

    const differenceInDays = Math.floor((date2.getTime() - date1.getTime()) / (1000 * 60 * 60 * 24));
    return Math.floor(differenceInDays / 365);

});